import React from 'react';
import { bool, array, func } from 'prop-types';

import LoadingState from '../../../LoadingState';
import MessageThreadHeaderList from '../MessageThreadHeaderList';

import s from './MessageThreadHeaderContainer.css';


const MessageThreadHeaderContainer = ({ ...props }) => {

  const getMessageThreadHeaderList = () => {
    if (props.isLoading) {
      return (
        <div className={s.messagePlaceholder}>
          <p className={s.loadingMessage}>
            Loading all your messages...
          </p>
          <LoadingState context="messageThreadHeaderList" />
        </div>
      );
    }
    else if (props.messageThreadHeaders) {
      return (
        <MessageThreadHeaderList
          messageThreadHeaders={props.messageThreadHeaders}
          handleMsgThreadDisplay={props.handleMsgThreadDisplay}
        />
      );
    }
    else {
      return (
        <p className={s.messagePlaceholder}>
          You have no messages.
        </p>
      );
    }
  };

  return getMessageThreadHeaderList();

};

MessageThreadHeaderContainer.propTypes = {
  isLoading: bool,
  messageThreadHeaders: array,
  handleMsgThreadDisplay: func,
};

export default MessageThreadHeaderContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadHeaderContainer/MessageThreadHeaderContainer.js